<template lang="pug">
  CrmFunnelFormApi(
    v-if="companyId"
    :companyId="companyId"
    :funnelId="funnelId"
    @change="onChange"
    @close="$emit('finish', true)"
    )
</template>

<script>
import CrmFunnelFormApi from '@/components/crm/CrmFunnelFormApi.vue';

export default {
  name: 'CrmFunnelPopupWrappable',
  components: { CrmFunnelFormApi },
  data() {
    return {
      companyId: null,
      funnelId: null,
      // колбэк страницы: попап могут закрыть крестиком, а список воронок и
      // выбранная воронка должны обновляться сразу по факту изменения
      changeCallback: null,
    };
  },
  methods: {
    init(params) {
      this.companyId = params.companyId;
      this.funnelId = params.funnelId ?? null;
      this.changeCallback = params.onChange ?? null;
    },
    onChange(funnelId) {
      this.changeCallback?.(funnelId);
    },
  },
};
</script>
